import { createEffect, onCleanup, Show, type JSX } from 'solid-js';
import { Portal } from 'solid-js/web';
import { IconButton } from './Button';
import { Icon } from './Icon';

export function Dialog(props: {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  width?: number;
  children?: JSX.Element;
  footer?: JSX.Element;
}): JSX.Element {
  createEffect(() => {
    if (!props.open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') props.onClose();
    };
    document.addEventListener('keydown', onKey);
    onCleanup(() => document.removeEventListener('keydown', onKey));
  });

  return (
    <Show when={props.open}>
      <Portal>
        {/* Clicking the scrim does nothing on purpose: a dialog is dismissed
            only through Cancel, Close or the X, so a stray click cannot throw
            away a half-filled form or hide a deployment in progress. */}
        <div class="tk-scrim">
          <div
            class="tk-dialog"
            role="dialog"
            aria-modal="true"
            aria-label={props.title}
            style={{ 'max-width': `${props.width ?? 480}px` }}
          >
            <div class="tk-dialog__head">
              <h3>{props.title}</h3>
              <IconButton label="Close" small onClick={() => props.onClose()}>
                <Icon name="close" size={18} />
              </IconButton>
            </div>
            <Show when={props.description}>
              <p class="tk-dialog__desc">{props.description}</p>
            </Show>
            {props.children}
            <Show when={props.footer}>
              <div class="tk-dialog__foot">{props.footer}</div>
            </Show>
          </div>
        </div>
      </Portal>
    </Show>
  );
}
